//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _doingCreate_metaui_dataDictionary from './doingCreate_metaui_dataDictionary';
export const doingCreate_metaui_dataDictionary = _doingCreate_metaui_dataDictionary;
export default {doingCreate_metaui_dataDictionary};

